import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useInvestorTypesStore from './state-hook';
import getTypes from './transform';
import Types from './types';
import ChartArea from './chart-area';
import Total from './total';
import VsPrev from './vs-prev';
import { Header, Row } from './styles';

const headerHeight = 56;
const rowHeight = 30;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > .chart {
    transform: translateY(5px);
    flex-grow: 2;
    height: ${props => props.n * rowHeight}px;
  }

  & > :not(.chart) {
    display: flex;
    flex-direction: column;

    .header {
      ${Header};
      height: ${headerHeight}px;
      display: flex;
      align-items: flex-start;
    }

    .cell {
      ${Row};
      height: ${rowHeight}px;
      display: flex;
      align-items: flex-end;
    }
  }
`;

export default function TypeGrid({ investorTypes }) {
  const events = useInvestorTypesStore(state => state.events);
  const daysAgo = useInvestorTypesStore(state => state.daysAgo);
  const [types, setTypes] = React.useState([]);

  React.useEffect(() => {
    setTypes(getTypes(events, daysAgo, investorTypes));
  }, [events, daysAgo, investorTypes]);

  const props = { types, daysAgo };
  return (
    <Container n={types.length}>
      <Types {...props} />
      <ChartArea {...props} />
      <Total {...props} />
      <VsPrev {...props} />
    </Container>
  );
}

TypeGrid.propTypes = {
  investorTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
};
